// Menu
export const RESET_VALUES = 'RESET_VALUES';

export const NAVIGATION_CLICK = 'NAVIGATION_CLICK';
export const TOGGLE_MENU = 'TOGGLE_MENU';


// WEBPACK FOOTER //
// ./src/actions/menu-actions.js